import { render, staticRenderFns } from "./LinkIpList.vue?vue&type=template&id=24aa2a57&scoped=true&"
import script from "./LinkIpList.vue?vue&type=script&lang=js&"
export * from "./LinkIpList.vue?vue&type=script&lang=js&"
import style0 from "./LinkIpList.vue?vue&type=style&index=0&id=24aa2a57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa2a57",
  null
  
)

export default component.exports